"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var client_1 = require("@apollo/client");
var index_1 = __importDefault(require("../index"));
function AsyncSelect(_a) {
    var query = _a.query, mode = _a.mode, onSelect = _a.onSelect, queryResultFormatter = _a.queryResultFormatter, queryVariablesFormatter = _a.queryVariablesFormatter, queryVariables = _a.queryVariables, _b = _a.defaultSearchValue, defaultSearchValue = _b === void 0 ? "" : _b, _c = _a.placeholder, placeholder = _c === void 0 ? "" : _c, restProps = __rest(_a, ["query", "mode", "onSelect", "queryResultFormatter", "queryVariablesFormatter", "queryVariables", "defaultSearchValue", "placeholder"]);
    var _d = client_1.useQuery(query, {
        variables: queryVariablesFormatter
            ? queryVariablesFormatter(defaultSearchValue, queryVariables)
            : queryVariables,
    }), loading = _d.loading, data = _d.data, refetch = _d.refetch;
    var options = react_1.useMemo(function () {
        return queryResultFormatter ? queryResultFormatter(data) : data;
    }, [data, queryResultFormatter]);
    var onChange = react_1.useCallback(lodash_1.debounce(function (searchValue) {
        var variables = queryVariablesFormatter
            ? queryVariablesFormatter(searchValue, queryVariables)
            : queryVariables;
        refetch(variables);
    }, 500), [queryVariablesFormatter, queryVariables]);
    return (react_1.default.createElement(index_1.default, __assign({ showSearch: true, labelInValue: true, allowClear: !loading, mode: mode, placeholder: placeholder, filterOption: false, onSearch: onChange, onSelect: onSelect, options: options, loading: loading, notFoundContent: loading ? react_1.default.createElement(antd_1.Spin, null) : null, onClear: function () { return onChange(defaultSearchValue); } }, restProps)));
}
exports.default = AsyncSelect;
